define('fukit/configuration/app.menu.service.configuration',['require','exports','module','backbone.radio'],function(require, exports, module) {
  var Radio = require('backbone.radio');

  var AppMenuServiceConfiguration = {
    radioRequests: {
      'appMenuServiceConfiguration options': 'options',
    },

    options: function() {
      return {
        layout: Radio.channel('layoutConfiguration').request('layout'),
        storage: Radio.channel('storageConfiguration').request('storage'),
      };
    },
  };

  module.exports = AppMenuServiceConfiguration;
});

